module.exports = __webpack_public_path__ + "assets/img/thumb-Brighten-Home-Loans-Website.20973e05.jpg";